import { TechnicalUserType } from "./constants";

export const actionTypes = {
  TECH_USER_CREATE: "TECH_USER_CREATE",
  TECH_USER_CREATE_SUCCESS: "TECH_USER_CREATE_SUCCESS",
  TECH_USER_CREATE_FAILURE: "TECH_USER_CREATE_FAILURE",
  TECH_USER_UPDATE: "TECH_USER_UPDATE",
  TECH_USER_UPDATE_SUCCESS: "TECH_USER_UPDATE_SUCCESS",
  TECH_USER_UPDATE_FAILURE: "TECH_USER_UPDATE_FAILURE",
  TECH_USER_DELETE: "TECH_USER_DELETE",
  TECH_USER_DELETE_SUCCESS: "TECH_USER_DELETE_SUCCESS",
  TECH_USER_DELETE_FAILURE: "TECH_USER_DELETE_FAILURE",

  TECH_USER_GET_PWD_POLICY: "TECH_USER_GET_PWD_POLICY",
  TECH_USER_GET_PWD_POLICY_SUCCESS: "TECH_USER_GET_PWD_POLICY_SUCCESS",
  TECH_USER_GET_PWD_POLICY_FAILURE: "TECH_USER_GET_PWD_POLICY_FAILURE",

  TECH_USER_BLOCK_ACCOUNT: "TECH_USER_BLOCK_ACCOUNT",
  TECH_USER_BLOCK_ACCOUNT_SUCCESS: "TECH_USER_BLOCK_ACCOUNT_SUCCESS",
  TECH_USER_BLOCK_ACCOUNT_FAILURE: "TECH_USER_BLOCK_ACCOUNT_FAILURE",
  TECH_USER_UNLOCK_ACCOUNT: "TECH_USER_UNLOCK_ACCOUNT",
  TECH_USER_UNLOCK_ACCOUNT_SUCCESS: "TECH_USER_UNLOCK_ACCOUNT_SUCCESS",
  TECH_USER_UNLOCK_ACCOUNT_FAILURE: "TECH_USER_UNLOCK_ACCOUNT_FAILURE",

  TECH_USER_RESET_PWD: "TECH_USER_RESET_PWD",
  TECH_USER_RESET_PWD_SUCCESS: "TECH_USER_RESET_PWD_SUCCESS",
  TECH_USER_RESET_PWD_FAILURE: "TECH_USER_RESET_PWD_FAILURE",
  TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP:
    "TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP",
  TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS:
    "TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS",
  TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_FAILURE:
    "TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_FAILURE",
  TECH_USER_RESET_PWD_VERIFY_UIGP_OTP: "TECH_USER_RESET_PWD_VERIFY_UIGP_OTP",
  TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_SUCCESS:
    "TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_SUCCESS",
  TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_FAILURE:
    "TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_FAILURE",
  TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS:
    "TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS",
  TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_SUCCESS:
    "TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_SUCCESS",
  TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_FAILURE:
    "TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_FAILURE",

  TECH_USER_CHANGE_PWD: "TECH_USER_CHANGE_PWD",
  TECH_USER_CHANGE_PWD_SUCCESS: "TECH_USER_CHANGE_PWD_SUCCESS",
  TECH_USER_CHANGE_PWD_FAILURE: "TECH_USER_CHANGE_PWD_FAILURE",
  TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP:
    "TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP",
  TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS:
    "TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS",
  TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_FAILURE:
    "TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_FAILURE",
  TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS:
    "TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS",
  TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_SUCCESS:
    "TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_SUCCESS",
  TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_FAILURE:
    "TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_FAILURE",
  TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP: "TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP",
  TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_SUCCESS:
    "TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_SUCCESS",
  TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_FAILURE:
    "TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_FAILURE",

  TECH_USER_TYPE: "TECH_USER_TYPE",
  TECH_USER_SELECT_OU: "TECH_USER_SELECT_OU",
  TECH_USER_SELECT_OU_NAME: "TECH_USER_SELECT_OU_NAME",
  TECH_USER_SELECT_TU: "TECH_USER_SELECT_TU",
  TECH_USER_SELECT_ACCOUNT: "TECH_USER_SELECT_ACCOUNT",
  TECH_USER_SET_APPLICATION_DETAIL: "TECH_USER_SET_APPLICATION_DETAIL",

  TECH_USER_GET_OU: "TECH_USER_GET_OU",
  TECH_USER_GET_OU_SUCCESS: "TECH_USER_GET_OU_SUCCESS",
  TECH_USER_GET_OU_FAILURE: "TECH_USER_GET_OU_FAILURE",

  TECH_USER_GET_TU: "TECH_USER_GET_TU",
  TECH_USER_GET_TU_SUCCESS: "TECH_USER_GET_TU_SUCCESS",
  TECH_USER_GET_TU_FAILURE: "TECH_USER_GET_TU_FAILURE",

  TECH_USER_GET_TU_ENTITLEMENTS: "TECH_USER_GET_TU_ENTITLEMENTS",
  TECH_USER_GET_TU_ENTITLEMENTS_SUCCESS:
    "TECH_USER_GET_TU_ENTITLEMENTS_SUCCESS",
  TECH_USER_GET_TU_ENTITLEMENTS_FAILURE:
    "TECH_USER_GET_TU_ENTITLEMENTS_FAILURE",

  TECH_USER_GET_ACCOUNT: "TECH_USER_GET_ACCOUNT",
  TECH_USER_GET_ACCOUNT_SUCCESS: "TECH_USER_GET_ACCOUNT_SUCCESS",
  TECH_USER_GET_ACCOUNT_FAILURE: "TECH_USER_GET_ACCOUNT_FAILURE",

  TECH_USER_GET_CATALOG_ENTITLEMENTS: "TECH_USER_GET_CATALOG_ENTITLEMENTS",
  TECH_USER_GET_CATALOG_ENTITLEMENTS_SUCCESS:
    "TECH_USER_GET_CATALOG_ENTITLEMENTS_SUCCESS",
  TECH_USER_GET_CATALOG_ENTITLEMENTS_FAILURE:
    "TECH_USER_GET_CATALOG_ENTITLEMENTS_FAILURE",

  TECH_USER_GET_APPLICATIONS: "TECH_USER_GET_APPLICATIONS",
  TECH_USER_GET_APPLICATIONS_SUCCESS: "TECH_USER_GET_APPLICATIONS_SUCCESS",
  TECH_USER_GET_APPLICATIONS_FAILURE: "TECH_USER_GET_APPLICATIONS_FAILURE",

  TECH_USER_SET_EXISTING_ENTITLEMENTS: "TECH_USER_SET_EXISTING_ENTITLEMENTS",
  TECH_USER_SET_ADDED_ENTITLEMENTS: "TECH_USER_SET_ADDED_ENTITLEMENTS",
  TECH_USER_SET_DELETED_ENTITLEMENTS: "TECH_USER_SET_DELETED_ENTITLEMENTS",

  TECH_USER_SET_IS_EDITING: "TECH_USER_SET_IS_EDITING",

  TECH_USER_RESET_STATE: "TECH_USER_RESET_STATE",
};

export const techUserCreateAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CREATE,
    payload,
  };
};
export const techUserCreateSuccessAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CREATE_SUCCESS,
    payload,
  };
};
export const techUserCreateFailureAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CREATE_FAILURE,
    payload,
  };
};

export const techUserUpdateAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_UPDATE,
    payload,
  };
};
export const techUserUpdateSuccessAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_UPDATE_SUCCESS,
    payload,
  };
};
export const techUserUpdateFailureAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_UPDATE_FAILURE,
    payload,
  };
};

export const techUserDeleteAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_DELETE,
    payload,
  };
};
export const techUserDeleteSuccessAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_DELETE_SUCCESS,
    payload,
  };
};
export const techUserDeleteFailureAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_DELETE_FAILURE,
    payload,
  };
};

export const techUsersTypeAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_TYPE,
    payload,
  };
};

export const techUsersSelectOuAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SELECT_OU,
    payload,
  };
};

export const techUsersSelectTuAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SELECT_TU,
    payload,
  };
};
export const techUsersSelectAccountAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SELECT_ACCOUNT,
    payload,
  };
};
export const techUsersSetApplicationDetailAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SET_APPLICATION_DETAIL,
    payload,
  };
};

export const techUsersGetOusAction = () => {
  return {
    type: actionTypes.TECH_USER_GET_OU,
  };
};
export const techUsersGetOusActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_OU_SUCCESS,
    payload,
  };
};
export const techUsersGetOusActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_OU_FAILURE,
    error,
  };
};

export const techUsersGetTechnicalUserAction = (payload: {
  ouCode: string;
  tiType?: TechnicalUserType;
}) => {
  return {
    type: actionTypes.TECH_USER_GET_TU,
    payload,
  };
};
export const techUsersGetTechnicalUserActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_TU_SUCCESS,
    payload,
  };
};
export const techUsersGetTechnicalUserActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_TU_FAILURE,
    error,
  };
};

export const techUsersGetTechnicalUserEntitlementsAction = (
  payload: string
) => {
  return {
    type: actionTypes.TECH_USER_GET_TU_ENTITLEMENTS,
    payload,
  };
};
export const techUsersGetTechnicalUserEntitlementsActionSuccess = (
  payload: any
) => {
  return {
    type: actionTypes.TECH_USER_GET_TU_ENTITLEMENTS_SUCCESS,
    payload,
  };
};
export const techUsersGetTechnicalUserEntitlementsActionFailure = (
  error: any
) => {
  return {
    type: actionTypes.TECH_USER_GET_TU_ENTITLEMENTS_FAILURE,
    error,
  };
};

export const techUsersGetAccountsAction = () => {
  return {
    type: actionTypes.TECH_USER_GET_ACCOUNT,
  };
};
export const techUsersGetAccountsActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_ACCOUNT_SUCCESS,
    payload,
  };
};
export const techUsersGetAccountsActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_ACCOUNT_FAILURE,
    error,
  };
};

export const techUsersGetCatalogEntitlementsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS,
    payload,
  };
};
export const techUsersGetCatalogEntitlementsActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS_SUCCESS,
    payload,
  };
};
export const techUsersGetCatalogEntitlementsActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS_FAILURE,
    error,
  };
};

export const techUsersGetApplicationsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_APPLICATIONS,
    payload,
  };
};
export const techUsersGetApplicationsActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_APPLICATIONS_SUCCESS,
    payload,
  };
};
export const techUsersGetApplicationsActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_APPLICATIONS_FAILURE,
    error,
  };
};

export const techUsersSetAddedEntitlementsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SET_ADDED_ENTITLEMENTS,
    payload,
  };
};

export const techUsersSetDeletedEntitlementsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SET_DELETED_ENTITLEMENTS,
    payload,
  };
};

export const techUsersSetExistingEntitlementsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_SET_EXISTING_ENTITLEMENTS,
    payload,
  };
};

export const techUsersSetIsEditingAction = (payload: boolean) => {
  return {
    type: actionTypes.TECH_USER_SET_IS_EDITING,
    payload,
  };
};

export const techUsersResetStateAction = () => {
  return {
    type: actionTypes.TECH_USER_RESET_STATE,
  };
};

export const techUsersBlockAccountAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_BLOCK_ACCOUNT,
    payload,
  };
};
export const techUsersBlockAccountActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_BLOCK_ACCOUNT_SUCCESS,
    payload,
  };
};
export const techUsersBlockAccountActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_BLOCK_ACCOUNT_FAILURE,
    error,
  };
};

export const techUsersUnlockAccountAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_UNLOCK_ACCOUNT,
    payload,
  };
};
export const techUsersUnlockAccountActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_UNLOCK_ACCOUNT_SUCCESS,
    payload,
  };
};
export const techUsersUnlockAccountActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_UNLOCK_ACCOUNT_FAILURE,
    error,
  };
};

export const techUsersResetPwdAccountAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD,
    payload,
  };
};
export const techUsersResetPwdAccountActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_SUCCESS,
    payload,
  };
};
export const techUsersResetPwdAccountActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_FAILURE,
    error,
  };
};

export const techUsersResetPwdVerifyCaMobileOtpAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP,
    payload,
  };
};
export const techUsersResetPwdVerifyCaMobileOtpActionSuccess = (
  payload: any
) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS,
    payload,
  };
};
export const techUsersResetPwdVerifyCaMobileOtpActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_FAILURE,
    error,
  };
};

export const techUsersResetPwdVerifySecQuestsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS,
    payload,
  };
};
export const techUsersResetPwdVerifySecQuestsActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_SUCCESS,
    payload,
  };
};
export const techUsersResetPwdVerifySecQuestsActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_FAILURE,
    error,
  };
};

export const techUsersResetPwdVerifyUigpOtpAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP,
    payload,
  };
};
export const techUsersResetPwdVerifyUigpOtpActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_SUCCESS,
    payload,
  };
};
export const techUsersResetPwdVerifyUigpOtpActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_FAILURE,
    error,
  };
};

export const techUsersChangePwdAccountAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD,
    payload,
  };
};
export const techUsersChangePwdAccountActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_SUCCESS,
    payload,
  };
};
export const techUsersChangePwdAccountActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_FAILURE,
    error,
  };
};

export const techUsersChangePwdVerifyCaMobileOtpAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP,
    payload,
  };
};
export const techUsersChangePwdVerifyCaMobileOtpActionSuccess = (
  payload: any
) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS,
    payload,
  };
};
export const techUsersChangePwdVerifyCaMobileOtpActionFailure = (
  error: any
) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_FAILURE,
    error,
  };
};

export const techUsersChangePwdVerifySecQuestsAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS,
    payload,
  };
};
export const techUsersChangePwdVerifySecQuestsActionSuccess = (
  payload: any
) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_SUCCESS,
    payload,
  };
};
export const techUsersChangePwdVerifySecQuestsActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_FAILURE,
    error,
  };
};

export const techUsersChangePwdVerifyUigpOtpAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP,
    payload,
  };
};
export const techUsersChangePwdVerifyUigpOtpActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_SUCCESS,
    payload,
  };
};
export const techUsersChangePwdVerifyUigpOtpActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_FAILURE,
    error,
  };
};

export const techUsersGetPwdPolicyAction = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_PWD_POLICY,
    payload,
  };
};
export const techUsersGetPwdPolicyActionSuccess = (payload: any) => {
  return {
    type: actionTypes.TECH_USER_GET_PWD_POLICY_SUCCESS,
    payload,
  };
};
export const techUsersGetPwdPolicyActionFailure = (error: any) => {
  return {
    type: actionTypes.TECH_USER_GET_PWD_POLICY_FAILURE,
    error,
  };
};
